import Checkbox from '@material-ui/core/Checkbox';
import Grow from '@material-ui/core/Grow';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useFormikContext } from 'formik';
import React from 'react';
import { useObservable } from 'react-use-observable';
import { AutoSizer, List as VList } from 'react-virtualized';
import selectAffiliateService from 'v2/services/affiliate/selectAffiliate';

import type { IAffiliateOption } from 'v2/interfaces/affiliate/selectAffiliate';

import { useStyles } from './styles';

import type { ListRowProps } from 'react-virtualized';

interface IProps {
  affiliates: IAffiliateOption[];
  selectedQuantity: number;
  selectedAffiliates: IAffiliateOption[];
}

type RowRenderExtends = 'key' | 'index';

interface RowRendererProps extends Pick<ListRowProps, RowRenderExtends> {
  style?: React.CSSProperties;
}

export const List = ({ affiliates, selectedAffiliates }: IProps) => {
  const classes = useStyles();

  const { setFieldValue } = useFormikContext();

  const [isLoadingAffiliates] = useObservable(() => selectAffiliateService.getIsLoading(), []);

  const selectedAffiliatesId = selectedAffiliates.map((aff) => aff.id);

  const handleSelectAffiliate = (affiliate: IAffiliateOption) => {
    const isAlreadySelected = selectedAffiliates.some((aff) => aff.id === affiliate.id);

    if (isAlreadySelected) {
      const filteredAffiliates = selectedAffiliates.filter((aff) => aff.id !== affiliate.id);

      setFieldValue('affiliates', filteredAffiliates);

      return;
    }

    setFieldValue('affiliates', [...selectedAffiliates, affiliate]);
  };

  const rowRenderer = ({ key, index, style }: RowRendererProps) => {
    const affiliate = affiliates[index];

    return (
      <ListItem key={key} className={classes.listItem} style={style} value={affiliate.id} onClick={() => handleSelectAffiliate(affiliate)}>
        <Checkbox checked={selectedAffiliatesId.includes(affiliate.id)} />
        <ListItemText primary={affiliate.name} secondary={affiliate.email} />
      </ListItem>
    );
  };

  const affiliatesSize = affiliates.length;
  const rowsLimit = 50;

  return (
    <>
      {!!affiliatesSize && affiliatesSize < rowsLimit && (
        <ul className={classes.listContainer}>{affiliates.map((affiliate, index) => rowRenderer({ key: String(affiliate.id), index }))}</ul>
      )}
      {!!affiliatesSize && affiliatesSize >= rowsLimit && (
        <AutoSizer>
          {({ height, width }) => <VList height={height} width={width} rowRenderer={rowRenderer} rowHeight={72} rowCount={affiliates.length} />}
        </AutoSizer>
      )}

      {!isLoadingAffiliates && !affiliatesSize && (
        <Grow in>
          <div className={classes.message}>
            <p>Nenhum afiliado encontrado</p>
          </div>
        </Grow>
      )}

      {isLoadingAffiliates && (
        <Grow in>
          <div className={classes.message}>
            <p>Carregando afiliados...</p>
          </div>
        </Grow>
      )}
    </>
  );
};
